import { Notify } from 'vant'

const GREEN = '#07c160'
const BLUE = 'var(--primary)'
const RED = '#ee0a24'
const ORANGE = '#FD996F'

export const danger = (message) => Notify({
  background: RED,
  message,
})

export const success = (message) => Notify({
  background: GREEN,
  message,
})

export const primary = (message) => Notify({
  background: BLUE,
  message,
})

export const warning = (message) => Notify({
  background: ORANGE,
  message,
})
